import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

/**
 * §9: **never encode meaning in colour alone.** Every badge in this product
 * carries its own text, and the risk badges pair the colour with a word and an
 * icon. The variants below are emphasis, not meaning.
 */
const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium leading-tight',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-secondary text-secondary-foreground',
        outline: 'border-border text-foreground',
        risk: 'border-amber-600/40 bg-amber-50 text-amber-900',
        danger: 'border-red-600/40 bg-red-50 text-red-900',
        success: 'border-emerald-600/40 bg-emerald-50 text-emerald-900',
        info: 'border-sky-600/40 bg-sky-50 text-sky-900',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps): React.ReactElement {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
